let css = require('./map-filter.css');
let $ = require('jquery');
let { setMapFilter } = require('../../../../../../signals/groups/order');
let { cut } = require('../../../../../../helpers/utils');
let SELECTOR_MAP = cut(css.map);
let SELECTOR_SEARCH = cut(css.search);
let mymap;
let editMode;
let editModeTimerId;

class MapFilter {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }, this.$context.props));
    }

    bind () {
        let polygon;
        this.$context.getWatcherData().then((data) => {
            // загрузка кода API карт
            let DG = require('2gis-maps');
            DG.then(function () {
                // загрузка кода модуля
                return DG.plugin('/static/assets/leaflet.draw/leaflet.draw.js');
            })
            .then(function () {
                // пересоздаём div с картой, чтобы не словить проблем
                let mapParent = document.getElementById('mapid-parent');
                let newMapDiv = document.createElement('div');
                newMapDiv.setAttribute('id', 'mapid');
                newMapDiv.className = SELECTOR_MAP.substring(1);
                mapParent.replaceChild(newMapDiv, document.getElementById('mapid'));
                // инициализация карты
                mymap = DG.map('mapid', { wheelPxPerZoomLevel: 50 });
                mymap.setView([55.000462844547805, 82.92549133300783], 11);

                // заменяем текст подсказок при рисовании
                L.drawLocal.draw.handlers.rectangle.tooltip.start = "Зажмите кнопку мыши, чтобы начать рисовать";
                L.drawLocal.draw.handlers.simpleshape.tooltip.end = "Отпустите кнопку, чтобы закончить рисовать";

                // отрисовываем геометрию, которая уже есть в заказе
                if(data.mapFilter) {
                    let coordinates = JSON.parse(data.mapFilter).coordinates;
                    let leftUpper = coordinates[0][0];
                    let rightBottom = coordinates[0][2];
                    let bounds = [[leftUpper[1], leftUpper[0]], [rightBottom[1], rightBottom[0]]];
                    // create an orange rectangle
                    polygon = DG.rectangle(bounds);
                    polygon.addTo(mymap);
                    // zoom the map to the rectangle bounds
                    mymap.fitBounds(bounds);
                    if(!data.isDisabled)
                    {
                        polygon.editing.enable();
                    }
                }

                // если заказа можно редактировать, то накрутим управление
                if(!data.isDisabled) {
                    // начинаем рисовать прямоуголник при клике по карте
                    mymap.on('click', function (e) {
                        // игнориуем клик, если недавно пользователь редактировал прямоугольник
                        // скорее всего пользователь просто отпустил кнопку мыши, когда менял размер и нам этот клик не нужен
                        if (editMode) {
                            return;
                        }

                        if (polygon) {
                            let leftTop = polygon._bounds._southWest;
                            let rightBottom = polygon._bounds._northEast;
                            // игнорируем нажатия внутри прямоугольника
                            // иначе при изменении размера прямоугольник может удалится
                            if (e.latlng.lng >= leftTop.lng && e.latlng.lng <= rightBottom.lng &&
                                e.latlng.lat >= leftTop.lat && e.latlng.lat <= rightBottom.lat)
                            {
                                return;
                            }

                            // удаляем старый прямоугольник
                            mymap.removeLayer(polygon);
                        }

                        // начинаем рисовать новый прямоугольник
                        let newPolygon = new L.Draw.Rectangle(mymap);
                        newPolygon.enable();
                    });

                    // по завершении рисования отображаем полигон и через событие передаём данные в catbee
                    mymap.on('draw:created', function (e) {
                        polygon = e.layer;
                        mymap.addLayer(polygon);
                        polygon.editing.enable();
                        DispatchMapFilterChanged();
                    });

                    function DispatchMapFilterChanged() {
                        editMode = false;
                        if (polygon) {
                            let element = document.getElementById('mapid');
                            let detail = JSON.stringify(polygon.toGeoJSON().geometry);

                            let event;
                            // первая часть специально для IE
                            if(document.createEvent){
                                event = document.createEvent("CustomEvent");
                                event.initCustomEvent("change",true,true,detail);
                            }
                            else{
                                event = new CustomEvent('change', {bubbles: true, cancelable: true, detail});
                            }

                            element.dispatchEvent(event);
                        }
                    }

                    // TODO: использование timeout можно заменить на _.debounce
                    // если пользователь перетащил прямоугольник или изменил его размер, то переходим в режим редактирования
                    // пересчитывать цену будем только после того, как пользователь 500мс ничего не делает
                    // а то событий сотни, нельзя так спамить WebAPI
                    function onEdit () {
                        editMode = true;
                        if (editModeTimerId) {
                            clearTimeout(editModeTimerId);
                            editModeTimerId = undefined;
                        }
                        editModeTimerId = setTimeout(DispatchMapFilterChanged, 500);
                    }

                    mymap.on('draw:editresize', onEdit);
                    mymap.on('draw:editmove', onEdit);
                }
            });
        });

        return {
            change: {
                ['#mapid']: this.filterChanged,
            },
            input: {
                ['#citySelect']: this.citySelected
            },
            keyup: {
                [SELECTOR_SEARCH]: this.searchChanged
            }
        };
    }

    citySelected (e) {
        e.stopPropagation();
        $.getJSON('https://catalog.api.2gis.ru/2.0/geo/search', {
            q: e.currentTarget.value,
            fields: 'items.geometry.centroid',
            type: 'adm_div.city,adm_div.settlement',
            limit: 1,
            key: 'rujlnh2071',
        }).done(function(data) {
            if(typeof data.result !== 'undefined') {
                let geo = data.result.items[0].geometry.centroid;
                geo = geo.replace('POINT(', '').replace(')', '').split(' ');
                mymap.setView([geo[1], geo[0]], 11);
            }
        });
    }

    filterChanged (e) {
        e.stopPropagation();
        this.$context.signal(setMapFilter, { mapFilter: e.detail });
    }

    searchChanged(e) {
        e.stopPropagation();
        document.getElementById("cityname").innerHTML = '';
        $.getJSON('https://catalog.api.2gis.ru/2.0/geo/search', {
            q: e.currentTarget.value,
            fields: 'items.geometry.centroid',
            type: 'adm_div.city,adm_div.settlement',
            limit: 1,
            key: 'rujlnh2071',
        }).done(function(data) {
            if(typeof data.result !== 'undefined') {
                document.getElementById("cityname").innerHTML = '<option value="' + data.result.items[0].name + '">';
                let geo = data.result.items[0].geometry.centroid;
                geo = geo.replace('POINT(', '').replace(')', '').split(' ');
                mymap.setView([geo[1], geo[0]], 11);
            }
        });
    }
}

module.exports = {
    constructor: MapFilter
};



// WEBPACK FOOTER //
// ./components/common/custom-order/cities/content/map-filter/index.js